import { AfterViewInit, ChangeDetectorRef, HostBinding, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from 'rxjs';

import type { IPromo } from './product-promo.interface';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SdTagComponent } from '../tags/tag/tag.component';
import { DeviceService } from '../../_services/device.service';
import { IconSizeEnum } from '../../_enums/icon.enum';
import { SdBannerComponent } from '../medias/banner/banner.component';
import { SdButtonComponent } from '../buttons/button/button.component';
import { SdButtonIconComponent } from '../buttons/button-icon/button-icon.component';
import { SdLinkComponent } from '../links/link/link.component';
import { SdModalDefaultComponent } from '../modals/modal-default/modal-default.component';
import { ThemesEnum } from '../../_enums/themes.enum';
import { SdHtmlComponent } from '../html/html.component';

@Component({
  selector: 'sd-product-promo',
  templateUrl: './product-promo.component.html',
  standalone: true,
  imports: [
    SdTagComponent,
    SdLinkComponent,
    SdBannerComponent,
    SdButtonIconComponent,
    SdModalDefaultComponent,
    SdButtonComponent,
    SdHtmlComponent
  ]
})
export class SdProductPromoComponent
implements AfterViewInit, OnInit, OnDestroy
{
  constructor(
    @Inject(PLATFORM_ID) protected platformId: any,
    @Inject(DOCUMENT) private document: Document,
    private cdRef: ChangeDetectorRef,
    private deviceService: DeviceService,
  ) {}

  themesEnum = ThemesEnum;
  isOpened = false;
  isMobile$: boolean;
  mobileSubscription: Subscription;
  bodyChildren;
  iconSizeEnum = IconSizeEnum;

  @Input()
  promo: IPromo;

  @Input()
  isQualiRepar = false;

  @Output()
  learnMoreClick = new EventEmitter<IPromo>();

  @Output()
  isOpenedChange = new EventEmitter<boolean>();

  @Input()
  class = ''; // override the standard class attr with a new one.
  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, this.isQualiRepar ? 'is-quali-repar' : '']
      .filter(Boolean)
      .join(' ');
  }

  ngOnInit() {
    this.mobileSubscription = this.deviceService.isMobile.subscribe((x) => {
      this.isMobile$ = x;
      this.cdRef.markForCheck();
    });
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.bodyChildren = this.document.body.children;
    }
  }

  ngOnDestroy() {
    this.mobileSubscription?.unsubscribe();
  }

  onClick() {
    this.learnMoreClick.emit(this.promo);
  }

  openModal() {
    this.isOpened = true;
    /*
     * A11y
     */
    for (const child of this.bodyChildren) {
      if (child.className !== 'cdk-overlay-container') {
        child.setAttribute('aria-hidden', true);
      }
    }
  }
}
